export const FETCH_RECIPIENTS_LIST = 'recipients/FETCH_RECIPIENTS_LIST';
export const RECEIVE_RECIPIENTS_LIST = 'RECEIVE_RECIPIENTS_LIST';
